import React from 'react';

export default class AccountNavItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const classNames = this.props.section == this.props.activePage ? 'active' : 'default';
    if (this.props.shouldRender == false) {
      return false;
    }
    const iconClassname = `icon-${this.props.section}`;
    return (
      <li onClick={() => this.props.onClickHandler(this.props.section)}>
        <a className={classNames}>
          <i className={iconClassname} />
          <span>{this.props.text}</span>
          {this.props.addendumText}
        </a>
      </li>
    );
  }
}
